module.exports = __webpack_public_path__ + "static/media/menu.f28e118a.svg";